module.exports = __webpack_public_path__ + "static/media/instagram.762bb409.png";